import { render, staticRenderFns } from "./MultiSelectPerson.vue?vue&type=template&id=d2987570&"
import script from "./MultiSelectPerson.vue?vue&type=script&lang=js&"
export * from "./MultiSelectPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports